import React, { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  ENTITYLIST,
} from "../../../core/constants";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Upload from "../../components/fieldUpload";
import CloseBar from "../../components/dialogCloseBar";
import notBackdropClicked from "../../components/helpers/notBackdropClicked";

function EditDialog(props) {
  const { 
    onClose,
    action,
    entityName,
    valueName,
    classes,
    scope: propsScope,
    entityType: propsEntityType,
    pattern: propsPattern 
  } = props;

  const [name, setName] = useState(null);
  const [scope, setScope] = useState(null);
  const [pattern, setPattern] = useState(null);
  const [entityType, setEntityType] = useState(null);
  const [formData, setFormData] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setName(entityName || valueName || "");
    setScope(propsScope || "custom");
    setEntityType(propsEntityType || "list");
    setPattern(propsPattern || "");
  }, [entityName, valueName, propsScope, propsEntityType, propsPattern]); //refresh effect if one of this params changed

  const handleClose = save => {
    onClose(save, { name, scope, entityType, formData, pattern });
  };

  const title = () => {
    if (action) {
      return t(`entities.${action}`);
    }
    
    return "";
  };

  return (
    <Dialog
      fullWidth={true}
      open={true}
      onClose={notBackdropClicked(() => handleClose(false))}
    >
      <CloseBar onClose={() => handleClose(false)} title={title()}/>
      <DialogContent dividers style={{ overflow: "hidden" }}>
        {action && action !== ENTITYLIST.UPLOAD_ENTITY && (
          <TextField
            required
            size="small"
            className={classes.dialogField}
            label={t("common.name")}
            onChange={(event) => {
              let value = event.target.value;
              if (
                action === ENTITYLIST.UPDATE_ENTITY ||
                action === ENTITYLIST.ADD_ENTITY
              ) {
                value = value.replace(/[^0-9A-Za-z-_.]/gi, "");
              }

              setName(value);
            }}
            variant="outlined"
            fullWidth
            value={name || ""}
            //defaultValue={action === ENTITYLIST.UPDATE_ENTITY || action === ENTITYLIST.UPDATE_VALUE ? name : null}
          />
        )}
        {action &&
          (action === ENTITYLIST.ADD_ENTITY ||
            action === ENTITYLIST.UPLOAD_ENTITY ||
            action === ENTITYLIST.UPDATE_ENTITY) && (
            <Fragment>
              {action !== ENTITYLIST.UPLOAD_ENTITY && (
                <TextField
                  select
                  className={classes.dialogField}
                  size="small"
                  label={t("entities.entity_type")}
                  fullWidth
                  value={entityType}
                  onChange={(event) => setEntityType(event.target.value)}
                  variant="outlined"
                >
                  {["list", "pattern", "any"].map((option, idx) => (
                    <MenuItem
                      value={option}
                      key={idx}
                      selected={option === entityType}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              )}
              <TextField
                select
                className={classes.dialogField}
                size="small"
                label={t("entities.entity_scope")}
                fullWidth
                value={scope}
                onChange={(event) => setScope(event.target.value)}
                variant="outlined"
              >
                {["custom", "public"].map((option, idx) => (
                  <MenuItem
                    value={option}
                    key={idx}
                    selected={option === scope}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
              {entityType === "pattern" && (
                <TextField
                  required
                  size="small"
                  className={classes.dialogField}
                  label={t("entities.pattern")}
                  onChange={(event) => setPattern(event.target.value)}
                  variant="outlined"
                  fullWidth
                  defaultValue={pattern || ""}
                />
              )}
            </Fragment>
          )}
        {action && action === ENTITYLIST.UPLOAD_ENTITY && (
          <div style={{ marginLeft: "8px" }}>
            <Upload
              onFileLoad={(fileType, formData) => setFormData(formData)}
              fileTypeRegex={/([a-zA-Z0-9\s_\\.\-():])+(.json)$/i}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="primary">
          {t("common.cancel")}
        </Button>
        <Button
          disabled={action && action === ENTITYLIST.UPLOAD_ENTITY? !formData: !name || !scope || !entityType || (entityType === "pattern" && !pattern)}
          onClick={() => handleClose(true)}
          color="primary"
          autoFocus
        >
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditDialog;
